import { render, staticRenderFns } from "./ifmNews.vue?vue&type=template&id=18eab743&scoped=true"
import script from "./ifmNews.vue?vue&type=script&lang=js"
export * from "./ifmNews.vue?vue&type=script&lang=js"
import style0 from "./ifmNews.vue?vue&type=style&index=0&id=18eab743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eab743",
  null
  
)

export default component.exports